import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Heading, Link } from "@ogt/ui";
import { FormModel } from "../types/FormTypes";
import { formDataAtom } from "../App";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { mapFormDataToPayload } from "../utils/mapFormDataToPayload";
import { URLS } from "src/config/urls";

export default function ThankYou() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  //const [issue] = useAtom(issueAtom);

  const isValidFormData = formData?.selectedJourney?.journeyKey;

  useEffect(() => {
    if (!isValidFormData) {
      navigate("/", { replace: true });
    }
  }, [isValidFormData, navigate]);

  if (!isValidFormData) return null;

  const payload = mapFormDataToPayload(formData);
  const emailContact = payload.Email;
  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("../fler-resor");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
      >
        {({ values }) => (
          <Form>
            <Box fullwidth>
              <Heading
                className="h2"
                focusable
                headingRef={h2Ref}
                id="thankYouHeading"
              >
                Tack för er anmälan!
              </Heading>
              <div role="group">
                <p>
                  Vi har tagit emot er anmälan. Ni får snart en kopia till
                  mejladressen:{" "}
                  <span className="sans-bold">{emailContact}</span>
                </p>
                <p>
                  Där finns ert referensnummer. Om ni kontaktar oss behöver ni
                  ange referensnumret. Hittar ni inte mejlet? Kolla i
                  skräpposten.
                </p>
                <Heading as="h3" className="">
                  Köp biljett
                </Heading>
                <p>
                  Biljetter köper ni enklast i vår app eller på{" "}
                  <Link underline="always" className="inline!" target="_blank" rel="noreferrer" href={URLS.mainWebsite}>
                    ostgotatrafiken.se
                  </Link>
                  . Tips! Köp biljetten tillsammans, så får ni 20 procent i
                  tillsammansrabatt.
                </p>

                <p>
                  Är ni en skolklass som ska resa? Då rekommenderar vi att ni
                  reser med kulturbiljetten. Den köper ni i vår{" "}
                  <Link underline="always" className="inline!" target="_blank" rel="noreferrer" href={URLS.companyPortal}>
                    företagsportal
                  </Link>
                  .
                </p>
              </div>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
}
